import * as React from 'react';
import {
    ButtonLinkWithIcon,
    ButtonWithIcon,
    ModalDrawer,
    useModal
} from '@blueprint/ui';
import { ListingSharing } from '@zoopla/listings/share';
import { ShareSmall } from '@blueprint/icons';
import { StyledBranchLogo, Text } from './Footer.styles';
import { BinOutlineSmall, EmailOutlineSmall } from '@blueprint/icons';
import { ListingUris } from '../../../graphql.generated';

type ShareModalButtonProps = {
    trackOpenShareModal: () => void;
    trackCloseShareModal: () => void;
    testId: string;
    title: string;
    listingId: string;
    listingUris: ListingUris;
};

export const ShareModalButton = ({
    trackOpenShareModal,
    trackCloseShareModal,
    testId,
    title,
    listingId,
    listingUris
}: ShareModalButtonProps) => {
    const onCloseShareModal = () => {
        trackCloseShareModal();
    };
    const [shareModalIsShowing, _openShareModal, closeShareModal] = useModal({
        onClose: onCloseShareModal
    });
    const openShareModal = () => {
        _openShareModal(null);
        trackOpenShareModal();
    };

    const shareModal = (
        <ModalDrawer
            isShowing={shareModalIsShowing}
            close={(event?: React.MouseEvent<HTMLElement>) => {
                event?.stopPropagation();
                closeShareModal();
            }}
        >
            <ListingSharing
                title={title}
                listingId={listingId}
                listingUrl={listingUris.detail || ''}
                sharingCategory="User Account"
            />
        </ModalDrawer>
    );

    return (
        <>
            <ButtonWithIcon
                variant="tertiary"
                onClick={openShareModal}
                data-testid={testId}
            >
                <ShareSmall />
                Share
            </ButtonWithIcon>
            {shareModal}
        </>
    );
};

export const BranchLogo = ({
    logoUrl,
    branchName
}: {
    logoUrl?: string | null;
    branchName?: string | null;
}) => {
    return logoUrl ? (
        <StyledBranchLogo
            src={logoUrl}
            alt={`Marketed by ${branchName}`}
            lazy={false}
        />
    ) : null;
};

export const PublishedOn = ({
    publishedOn
}: {
    publishedOn?: string | null;
}) => {
    if (!publishedOn) {
        return null;
    }

    const formattedDate = new Intl.DateTimeFormat('en-GB').format(
        Date.parse(publishedOn)
    );
    return <Text>Listed on {formattedDate}</Text>;
};

export const ContactButton = ({
    href,
    onClick,
    testId
}: {
    href: string;
    onClick: () => void;
    testId: string;
}) => (
    <ButtonLinkWithIcon
        href={href}
        variant="tertiary"
        onClick={onClick}
        data-testid={testId}
    >
        <EmailOutlineSmall /> Contact
    </ButtonLinkWithIcon>
);

export const DeleteButton = ({
    testId,
    onClick
}: {
    testId: string;
    onClick: () => void;
}) => {
    return (
        <ButtonWithIcon
            variant="tertiary"
            onClick={onClick}
            data-testid={testId}
        >
            <BinOutlineSmall />
            Remove
        </ButtonWithIcon>
    );
};
